import routerOptions0 from "/home/runner/work/web/web/node_modules/.pnpm/nuxt@3.13.2_@parcel+watcher@2.4.1_@types+node@20.16.12_encoding@0.1.13_eslint@8.57.0_ioredis@_y7tvohuwk7i36lpqzsfg64pbne/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}